import React from "react";
import Routers from "../routers/Routers";
import Navbar from "./sub-comps/Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhtsappButton";
import ReviewsWidget from "./sub-comps/MoreReviews";
import { useLocation } from "react-router-dom";

function Layout() {
  const location = useLocation()
  return (
    <>
      <Navbar />
      <Routers />
      {/* <ReviewsWidget/> */}
      {location.pathname !== "/more-reviews" && <Footer />}
      {/* <WhatsAppButton /> */}
    </>
  );
}

export default Layout;
